import React, { useRef, useEffect, useState } from "react";
import drawGrid from "./drawGrid";

/**
 * PlottingPad – an interactive canvas for students to plot, move, and clear points.
 * Similar to WritingPad/Calculator, but specialized for coordinate plotting.
 */
export default function PlottingPad({
  widthCells = 10,
  heightCells = 10,
  cellSize    = 30
}) {
  const canvasRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [dragIdx, setDragIdx] = useState(null);

  // Redraw grid and points whenever state changes
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    // draw only the grid first
    drawGrid(canvas, { widthCells, heightCells, cellSize }, []);
    // overlay our points
    points.forEach(({ x, y }) => {
      const cx = x * cellSize;
      const cy = y * cellSize;
      ctx.beginPath();
      ctx.arc(cx, cy, cellSize / 4, 0, 2 * Math.PI);
      ctx.fillStyle = "red";
      ctx.fill();
      ctx.font = `${cellSize / 3}px sans-serif`;
      ctx.fillText(`(${x},${y})`, cx + 5, cy - 5);
    });
  }, [points, widthCells, heightCells, cellSize]);

  // Handle clicking: add new point or start dragging existing
  function handleMouseDown(e) {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = Math.round((e.clientX - rect.left) / cellSize);
    const y = Math.round((e.clientY - rect.top)  / cellSize);
    const idx = points.findIndex(p => p.x === x && p.y === y);
    if (idx >= 0) {
      setDragIdx(idx);
    } else {
      setPoints(prev => [...prev, { x, y }]);
    }
  }
  // Handle dragging: move the selected point
  function handleMouseMove(e) {
    if (dragIdx === null) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const x = Math.round((e.clientX - rect.left) / cellSize);
    const y = Math.round((e.clientY - rect.top)  / cellSize);
    setPoints(prev => prev.map((pt,i) => i === dragIdx ? { x, y } : pt));
  }
  function handleMouseUp() {
    setDragIdx(null);
  }

  // Clear all plotted points
  function clearAll() {
    setPoints([]);
    setDragIdx(null);
  }

  return (
    <div className="plotting-pad-container" style={{ textAlign: "center" }}>
      <canvas
        ref={canvasRef}
        width={widthCells * cellSize}
        height={heightCells * cellSize}
        style={{ border: "1px solid #444", cursor: "crosshair" }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
      />
      <div style={{ marginTop: 8 }}>
        <button className="button1" onClick={clearAll}>Clear All</button>
      </div>
    </div>
  );
}
